import { config } from "src/config";

export const TRIP_DETAILS_PATH = "/#/routing/performance/list/trip";

export const TRIP_DETAILS_TAB = "1";

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isTripIdentifier = (value?: string | null): value is string => UUID_PATTERN.test(value?.trim() ?? "");

export interface TripDetailsTarget {
  tripId?: string | null;
  driverId?: string | null;
}

const withoutTrailingSlashes = (value: string): string => {
  let end = value.length;

  while (end > 0 && value[end - 1] === "/") end -= 1;

  return value.slice(0, end);
};

export const buildTripDetailsUrl = ({ tripId, driverId }: TripDetailsTarget): string | null => {
  const baseUrl = config.routingAppUrl?.trim();
  const trip = tripId?.trim();
  const driver = driverId?.trim();

  if (!baseUrl || !driver || !isTripIdentifier(trip)) return null;

  const query = `tripId=${encodeURIComponent(trip)}&driverId=${encodeURIComponent(driver)}&tab=${TRIP_DETAILS_TAB}`;

  return `${withoutTrailingSlashes(baseUrl)}${TRIP_DETAILS_PATH}?${query}`;
};

export const openTripDetails = (target: TripDetailsTarget): boolean => {
  const url = buildTripDetailsUrl(target);

  if (!url) return false;

  window.open(url, "_blank", "noopener");

  return true;
};
